var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',{attrs:{"direction":_vm.direction,"content-position":_vm.contentPosition}},[_vm._v(" "+_vm._s(_vm.content)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }